import { getCmsNewsListAction } from "../../../Actions/LogicActions/CMSNews/GetCMSNewsList";
import { newsCardClickAction } from "../../../Actions/UIActions/CMSNews/NewsCardClickAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { INewsDetailGetParams } from "../../../Orchestrator/Types/Interface/ICMSNews";

export class NewsWidgetStep extends StepFlow {
  get stepName() {
    return "NewsWidgetStep";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on({
        eventName: evtTree.News.List.Get,
        handler: async () => {
          getCmsNewsListAction.execute();
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<INewsDetailGetParams, void>({
        eventName: evtTree.News.Card.Click,
        handler: async (data) => {
          newsCardClickAction.setParams(data.data!);
          await newsCardClickAction.execute();
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("NewsWidgetStep Init Step Execute...");

    this.eventBus.emit({
      eventName: evtTree.News.List.Get,
    });
  }
}
export const newsWidgetStepDeclaration = new StepDefinition({
  stepName: "NewsWidgetStep",
  stepClass: NewsWidgetStep,
});
